import { Link } from "react-router-dom";



export function NotFound(){

    return (
        <div className="mega-max">
            <div className="content max">
                <div className="abs-mid-y fw">
                    <div className="fw flex-col mid-align gap-3">
                        <p className="fw-800 fs-1">
                            ERROR 404
                        </p>
                        <div className="flex-col gap-2">
                            <p className="fs-5">
                                OOPS seems ypu have X-plored too far, lets get you back on track: <br></br>
                                <span className="fw-400">
                                    Back to:
                                </span>
                            </p>
                            <div className="flex-col gap-1">
                                <Link to='/'>
                                    Landing Page
                                </Link>
                                <Link to='/app'>
                                    App
                                </Link>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <ErrorBug />
        </div>
    )
}

function ErrorBug(){

    return (
        <small>
            If the problem persists, contact our support team
        </small>

    )
}